import { render } from "./Darek.vue?vue&type=template&id=17325ed6&ts=true"
import script from "./Darek.vue?vue&type=script&lang=ts"
export * from "./Darek.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__